import Vue from "vue";

const INITIALIZE_COLLECTION = "populateCollection";
const ADD_COLLECTION_ITEM = "addCollectionItem";
const REMOVE_COLLECTION_ITEM = "removeCollectionItem";
const ACTIVATE_COLLECTION_ITEM = "activateCollectionItem";
const DEACTIVATE_COLLECTION_ITEM = "deactivateCollectionItem";

export default {
	state: () => ({
		path: [],
		multiple: false,
		base: {
			state: {},
			module: {},
		},
		items: {},
	}),
	getters: {
		getById: (state) => (id) => state.items[id],
		list: (state) => state.items,
		array: (state, getters) => Object.values(getters.list),
		ordered: (state, getters) => getters.array.sort((itemA, itemB) => itemA.order - itemB.order),
		"collection/itemState": (state, getters, rootState) => (path) => path.reduce(
			(reducedState, pathComponent) => reducedState[pathComponent], rootState
		),
	},
	actions: {
		"collection/populate": function populate({ dispatch, commit }, collection) {
			commit(INITIALIZE_COLLECTION, collection);

			Object.values(collection.items).forEach((item) => {
				dispatch("collection/add", item);
			});
		},
		"collection/add": function add(context, item) {
			context.commit(ADD_COLLECTION_ITEM, item);
		},
		"collection/remove": function remove(context, item) {
			context.commit(REMOVE_COLLECTION_ITEM, item);
		},
		"collection/activate": async function activate({ dispatch, commit, state }, item) {
			const path = item.path ? item.path : state.path;

			if (this.hasModule(path)) {
				await dispatch("collection/deactivate", item);
			}

			commit(ACTIVATE_COLLECTION_ITEM, { ...item, path });

			if (state.base.module.actions?.activate) {
				dispatch(`${path.join("/")}/activate`, item, { root: true });
			}
		},
		"collection/deactivate": function deactivate({ commit, state, getters }, item) {
			const path = item?.path ? item.path : state.path;
			const itemState = item.state ? item.state : getters["collection/itemState"](path);

			commit(DEACTIVATE_COLLECTION_ITEM, { ...itemState, path });
		},
	},
	mutations: {
		[INITIALIZE_COLLECTION](state, collection) {
			state.multiple = "multiple" in collection ? collection.multiple : state.multiple;
			state.path = collection.path ? collection.path : [];
			state.base = {
				module: collection.module,
				state: typeof collection.module.state === "function" ? collection.module.state() : collection.module.state,
			};
		},
		[ADD_COLLECTION_ITEM](state, item) {
			state.items[item.id] = item;
		},
		[REMOVE_COLLECTION_ITEM](state, item) {
			Vue.delete(state.items, item.id);
		},
		[ACTIVATE_COLLECTION_ITEM](state, item) {
			this.registerModule(item.path, {
				...state.base.module,
				state: { ...state.base.state, ...state.items[item.id], ...item },
			});
		},
		[DEACTIVATE_COLLECTION_ITEM](state, item) {
			Vue.set(state.items, item.id, item);
			this.unregisterModule(item.path);
		},

	},
};
